import urlParse from "url-parse";

function linkCleaner(link: string) {
  if (!link || link === "") return link;

  const linkWithProtocol = link.startsWith("http") ? link : `https://${link}`;

  const { protocol, host, pathname } = urlParse(linkWithProtocol);
  if (pathname != "/") {
    return `${protocol}//${host}${pathname}`;
  } else {
    return `${protocol}//${host}`;
  }
}

export default linkCleaner;
